
import { ticketsData } from '../../../mocks/tickets';

export default function Tickets() {
  return (
    <section id="tickets" className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light mb-6 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Access Levels
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose your experience. Limited availability.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {ticketsData.map((ticket, index) => (
            <div 
              key={index}
              className={`relative bg-white border ${ticket.featured ? 'border-[#14B8A6] shadow-xl' : 'border-gray-200'} p-8 hover:shadow-2xl transition-all duration-300 group cursor-pointer`}
            >
              {ticket.featured && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#14B8A6] text-white px-6 py-1 text-xs tracking-widest whitespace-nowrap">
                  MOST POPULAR
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-light mb-2 tracking-wide">{ticket.tier}</h3>
                <div className="text-4xl font-light mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  ${ticket.price}
                </div>
                <p className="text-sm text-gray-500">{ticket.availability}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {ticket.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-sm">
                    <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>

              <button className={`w-full py-3 text-sm tracking-widest transition-all whitespace-nowrap ${ticket.featured ? 'bg-[#14B8A6] text-white hover:bg-[#0F9B8E]' : 'border border-black text-black hover:bg-black hover:text-white'}`}>
                SELECT
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
